import React, { useRef } from 'react';
import Loader from "react-loader-spinner";
import { X, Search } from 'react-bootstrap-icons';
import { Table, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { setSelectStaffPopup } from '../store/api/Modals';
import { getRelatedStaffsToAgent, getAgentList, getMiddlemanList } from "../store/api/StaffApi";
const ModalSelectStaff = () => {
    const searchData = useRef({});
    const pop = useSelector(state => state.popup.popSelectStaff);
    const { relatedStaffs, agentList, middlemanList } = useSelector(state => { return { relatedStaffs: state.StaffData.relatedStaffs, agentList: state.StaffData.agentList, middlemanList: state.StaffData.middlemanList } })
    const list = pop.forAgency ? agentList : pop.forMiddleman ? middlemanList : relatedStaffs;
    const dispatch = useDispatch();
    const { show, onSelect } = pop;

    const cancel = () => {
        if (onSelect)
            onSelect(null);
        dispatch(setSelectStaffPopup({ show: false }));
    }
    const selectStaff = (item) => {
        onSelect(item);
        dispatch(setSelectStaffPopup({ show: false }));
    }
    const search = (e) => {
        if(e.key && e.key !=="Enter")
        {
            return;
        }
        searchData.current.Take = 5;
        if (pop.forAgency) {
            dispatch(getAgentList(searchData.current));
        }
        else if (pop.forMiddleman) {
            dispatch(getMiddlemanList(searchData.current));
        }
        else {
            dispatch(getRelatedStaffsToAgent(searchData.current));
        }
    }
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}>{"انتخاب " + (pop.forAgency ? "نماینده" : "تکنسین")}<span onClick={cancel} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body>
                <div className='row' style={{ marginLeft: "2px", marginRight: "2px" }}>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder='کد تکنسین/نماینده' type="text" className='form-control' onKeyDown={search}
                        onChange={(e) => searchData.current.Code = e.target.value} />
                    </div>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder='نام تکنسین/نماینده' type="text" className='form-control' onKeyDown={search} 
                        onChange={(e) => searchData.current.Name = e.target.value} />
                    </div>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder='موبایل تکنسین/نماینده' type="text" className='form-control' onKeyDown={search} 
                        onChange={(e) => searchData.current.Mobile = e.target.value} />
                    </div>
                    <Button className="mt-2 mb-2" onClick={search}><Search size={20} />جستجو</Button>
                </div>
                <Table>
                    <thead>
                        <tr>
                            <th style={{ display: "none" }}></th>
                            <th>{"کد " + (pop.forAgency ? "نماینده" : "تکنسین")}</th>
                            <th>{"نام " + (pop.forAgency ? "نماینده" : "تکنسین")}</th>
                            <th>موبایل</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(list === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center" }}>
                                    <Loader type="BallTriangle" color="#bb1370" height={30} width={30} />
                                </td>
                            </tr>
                        }
                        {list && Array.isArray(list) &&
                            list.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => selectStaff(item)}>
                                    <td style={{ display: "none" }}></td>
                                    <td>{item.Code}</td>
                                    <td>{item.LastName}</td>
                                    <td>{item.Mobile}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalSelectStaff;